<template>
  <div class="duel-transcript">
    <ol v-if="records.length" class="transcript-list mb-0 pl-0">
      <li v-for="(record, index) in records" :key="record.id || index" class="transcript-row" :class="isA(record) ? 'side-a' : 'side-b'">
        <div class="transcript-item">
          <div class="d-flex justify-content-between align-items-baseline mb-1">
            <strong>{{ speaker(record) }}</strong>
            <small v-if="record.timestamp" class="text-muted ml-3">{{ record.timestamp }}</small>
          </div>
          <div class="transcript-content">{{ record.chatContent }}</div>
        </div>
      </li>
    </ol>
    <p v-else class="text-muted mb-0">尚無對話紀錄。</p>
  </div>
</template>

<script>
export default {
  name: "DuelTranscript",
  props: {
    records: { type: Array, default: () => [] },
    npcA: { type: String, default: "" },
  },
  methods: {
    speaker(record) { return record.chatName || record.character || "NPC"; },
    isA(record) { return record.character === this.npcA; },
  },
};
</script>

<style scoped>
.transcript-list { list-style: none; }
.transcript-row { display: flex; margin-bottom: 0.75rem; }
.transcript-row.side-a { justify-content: flex-start; }
.transcript-row.side-b { justify-content: flex-end; }
.transcript-item { width: min(78%, 680px); padding: 0.75rem 1rem; border-radius: 0.85rem; }
.side-a .transcript-item { background: #f1f3f5; border-bottom-left-radius: 0.2rem; }
.side-b .transcript-item { background: #dbeafe; border-bottom-right-radius: 0.2rem; }
.transcript-content { white-space: pre-wrap; overflow-wrap: anywhere; }
</style>
